import { Component, Input, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Banniere, BanniereService } from '@helvetia/components'
import { TypeSupport } from 'src/app/models/type-support'
import { TypeSupportService } from 'src/app/services/type-support.service'

@Component({
  selector: 'app-edit-type-support',
  templateUrl: './edit-type-support.component.html',
  styleUrls: ['./edit-type-support.component.scss']
})
export class EditTypeSupportComponent implements OnInit {

  typeSupport = new TypeSupport()

  listImg = ['création type de support 1.svg', 'création type de support 2.svg', 'création type de support 3.svg']
  imgSelected = ''
  isMarket: any

  constructor(public router: Router,
    public typeSupportService: TypeSupportService,
    public banniereService: BanniereService) {
    if (window.location.pathname.includes('creation')) {
      this.typeSupport.marketId = parseInt(window.location.pathname.split('/').slice(-1)[0])
      this.isMarket = true
    } else {
      this.typeSupport.id = parseInt(window.location.pathname.split('/').slice(-1)[0])
      this.isMarket = false
    }
  }


  ngOnInit(): void {
    if (this.typeSupport.id) {
      this.typeSupportService.getTypeSupportById(this.typeSupport.id).subscribe(
        (typeSupport) => {
          this.typeSupport = typeSupport
          this.imgSelected = this.typeSupport.icon
        }
      )
    }
  }

  updateTypeSupport() {
    if (this.typeSupport.id) {
      this.typeSupportService.updateTypeSupport(this.typeSupport).subscribe(
        (data) => {
          let banniere = new Banniere()
          banniere.text = 'Le type de support a bien été modifié'
          banniere.status = 'success'
          this.banniereService.setStatus(banniere)
          this.router.navigate(['documents/' + this.typeSupport.marketId])
        }
      )
    } else {
      this.typeSupportService.postTypeSupport(this.typeSupport).subscribe(
        (data) => {
          let banniere = new Banniere()
          banniere.text = 'Le nouveau type de support a bien été créé'
          banniere.status = 'success'
          this.banniereService.setStatus(banniere)
          this.router.navigate(['documents/' + this.typeSupport.marketId])
        }
      )
    }
  }

  selectedIcon(img: any) {
    this.imgSelected = img
    this.typeSupport.icon = this.imgSelected
  }

}
